import { tap } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { RequestService } from './request.service';
import { UserDetails } from '../types/user-details';
import { SessionService } from './session.service';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable()
export class PermissionsService {

  constructor(
    private injector: Injector,
  ) {
  }

  get ngxPermissions() {
    return this.injector.get(NgxPermissionsService);
  }

  get request() {
    return this.injector.get(RequestService);
  }

  get session() {
    return this.injector.get(SessionService);
  }

  async initialize() {
    return lastValueFrom(this.request
      .get(['me', 'details'])
      .pipe(
        tap((user: UserDetails) => {
          this.session.currentlyLoggedOperator = user;
          this.ngxPermissions.loadPermissions(user.roles);
        })
      ))
      .catch(err => {
        if (err.status === 403) {
          this.session.logout();
        }
      });
  }
}
